import { controls } from "../../controls";



const rp006 = {
  label: "GL Product & Balance Checking",
  starting: true,
  url: "rp006",
  pageLabel: "GL Product & Balance Checking",
  pageType: "history",
  form: [],
  filter: [
    ...controls.displayText({ tab: "filter", label: "Region", width: "col-sm-2" }),
    ...controls.Region({ tab: "filter", }),
    ...controls.showData({ tab: "filter", name: "region_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-3" }),
    {
      inputType: "checkbox",
      tab: "filter",
      default: "false",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Difference Only",
      name: "isDifferenceOnly",
      description: ""
    },
    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", }),
    ...controls.displayText({ tab: "filter", width: "col-sm-3" }),

    {
      inputType: "checkbox",
      // default: "false",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Summaray",
      name: "isSummaray",
      description: ""
    },
    ...controls.displayText({ tab: "filter", label: "GL Sub Head Group", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter",
      name: "product_group", width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "Deposite",
        value: "Deposite"
      },
      {
        label: "Loan",
        value: "Loan"
      },
      {
        label: "Bank",
        value: "Bank"
      },
      {
        label: "Other",
        value: "Other"
      },
      {
        label: "Internal",
        value: "Internal"
      }]
    }),
    ...controls.displayText({ tab: "filter", width: "col-sm-5" }),

    {
      inputType: "checkbox",

      default: "false",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Without Branch Adjustment",
      name: "isWithoutBranchAdjustment",
      description: ""
    },
    ...controls.displayText({ tab: "filter", label: "Product Type", width: "col-sm-2" }),
    ...controls.ProductType({
      tab: "filter",
    }),
    ...controls.showData({ tab: "filter", data: "product_type_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),

    ...controls.displayText({ tab: "filter", label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ tab: "filter", }),
    ...controls.showData({ tab: "filter", data: "product_code_display", name: "product_code_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.magicDateLabel({ tab: "filter", star: true, label: "As On Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", isRequired: true, dateType: "ontype", name: "as_on_date", width: "col-sm-2", default: "sessiondate" }),
  ],
  history: {
    perPage: 10,
    reportHeader: "Sub Day Book",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    subtotals: {
      grandtotal: { fields: ["credit_cash", "credit_transfer", "credit_total", "debit_cash", "debit_transfer", "debit_total"], count: true },
      subtotal: [{ by: "account_number", displayIn: "account_number", text: "Sub Total", count: true, groupedRows: false }]
    },
    displayColumns: [
      {
        Header: "Sr",
        type: "autoinc",
        accessor: "srno",
        width: 30,
      },
      {
        Header: "Account Number",
        accessor: "account_number",
      },
      {
        Header: "Description",
        accessor: "description",
        width: 300,
        rwidth: "*"
      },
      {
        Header: "Credit",
        columns: [
          {
            Header: "Cash",
            accessor: "credit_cash",
            type: "currency"
          },
          {
            Header: "Transfer",
            accessor: "credit_transfer",
            type: "currency"
          },
          {
            Header: "Total",
            accessor: "credit_total",
            type: "currency",
            formula: [{ f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'fixed', field: 'credit_cash' }, { source: 'fixed', field: 'credit_transfer' }], resultVar: 'total' }],
          }
        ]
      },
      {
        Header: "Debit",
        columns: [
          {
            Header: "Cash",
            accessor: "debit_cash",
            type: "currency"
          },
          {
            Header: "Transfer",
            accessor: "debit_transfer",
            type: "currency"
          },
          {
            Header: "Total",
            accessor: "debit_total",
            type: "currency",
            formula: [{ f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'fixed', field: 'debit_cash' }, { source: 'fixed', field: 'debit_transfer' }], resultVar: 'total' }],
          }
        ]
      },
    ]
  }
}
export default rp006;